import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IArticle } from '../../shared/types/articles';

import { PublicationPageState } from './publication.interface';

const initialState: PublicationPageState = {
  items: [],
  offset: 0,
};

export const publicationSlice = createSlice({
  name: 'mainPageSlice',
  initialState,
  reducers: {
    setPublicationItems(state, action: PayloadAction<any[]>) {
      state.items = action.payload;
    },
    setPublicationOffset(state, action: PayloadAction<number>) {
      state.offset = action.payload;
    },
  },
});

export const publicationActions = publicationSlice.actions;
export const { reducer } = publicationSlice;
